export default function splitStringInHalf(s) {
  if (s.length <= 4) return s;

  let middle = Math.floor(s.length / 2);
  const before = s.lastIndexOf("", middle);
  const after = s.indexOf("", middle + 1);
  const s1 = s.substr(0, before);
  const s2 = s.substr(after - 1);
  return `${s1}\n${s2}`;
}
